import sort from './sort'

const main = [
  {
    order: 1,
    title: 'ANEXO IV do Programa Leite Mais',
    chip: false,
    route: 'full-anexo-ix-print'
  },
  {
    order: 2,
    title: 'ANEXO IV do Programa Leite Mais',
    chip: {
      text: 'Documento em branco',
      icon: 'error_outline',
      iconColor: 'warning'
    },
    route: 'empty-anexo-ix-print'
  }
]

export default () => sort('order', main)
